export default {
    info: "Information",
    informe: "Report",
    notas: "Notes",
    presupuesto: "Budget",
    rma: "RMA",
    repuestos: "Spare parts",
    adjuntos: "Attachments",
    firma: "Signature",
    checklist: "Checklists",
    fallas: "Failures",
    datosCliente: "Client data",
    datosEquipo: "Equipment data",
    datosAdicionales: "Additional data",
    asignarTecnico: "Assign technician",
    general: "General",
    financiero: "Financial",
    ubicacion: "Location",
    obra: "Work",
    historial: "History",
    contacto: "Contact",
    facturacion: "Billing",
    observaciones: "Observations",
    equipos: "Equipment",
    sucursales: "Branches",
}
